import {
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LoadingService, SessionManagerService } from '@ops/shared-types';
import { catchError, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Inject the current `AuthService` and use it to get an authentication token:
    const loadingInstance = inject(LoadingService);
    const sessionInstance = inject(SessionManagerService);
    // Clone the request to add the authentication header.

    const urlsPrefixCheck = ['ops-be-staging', 'ops-be-dev', 'ops-be'];
    const checkAndVerifyCriteria = (reqUrl: string) => {
      const apiUrl = reqUrl?.split('.')[0]?.slice(8);
      if (urlsPrefixCheck.includes(apiUrl)) {
        if (
          reqUrl.indexOf('comment') === -1 &&
          reqUrl.indexOf('/enum') === -1
        ) {
          return true;
        }
      }
      return false;
    };

    return next.handle(req).pipe(
      tap((event) => {
        if (
          event.type === HttpEventType.Sent &&
          checkAndVerifyCriteria(req.url)
        ) {
          // console.log('START');
          loadingInstance.startLoadingSpinner();
        }
        if (
          event.type === HttpEventType.Response &&
          checkAndVerifyCriteria(req.url)
        ) {
          // console.log('STOP');
          loadingInstance.stopLoadingSpinner();
        }
      }),
      catchError((error: any) => {
        if (error?.error?.message === 'User is not authenticate') {
          sessionInstance.logout();
        }
        // console.log()
        throw new HttpErrorResponse(error || {});
      })
    );
  }
}
